// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'documents';

export const Component = () => (
  <path d='m17.852.431 5.317 5.317c.287.287.431.622.431 1.054v13.314c0 .43-.144.766-.431 1.054a1.408 1.408 0 0 1-1.054.43h-1.437v1.438c0 .43-.144.766-.431 1.053a1.408 1.408 0 0 1-1.054.432H3.484c-.382 0-.718-.144-1.005-.432-.24-.287-.431-.622-.479-1.053V4.407c.048-.431.24-.814.479-1.054a1.378 1.378 0 0 1 1.005-.431H4.97V1.485c0-.431.143-.766.431-1.054A1.408 1.408 0 0 1 6.454 0h10.344c.432 0 .767.144 1.054.431Zm.335 5.46h3.688l-4.166-4.214v3.735c0 .336.143.48.479.48Zm1.486 17.146V21.6H6.453a1.41 1.41 0 0 1-1.053-.431 1.408 1.408 0 0 1-.431-1.054V3.927H3.484c-.335 0-.479.144-.479.48v18.63c0 .335.144.479.48.479h15.708c.335 0 .479-.144.479-.48Zm2.97-2.922V6.848h-4.455c-.335 0-.67-.143-1.005-.382a1.408 1.408 0 0 1-.431-1.054L16.704.958H6.454c-.334 0-.526.191-.526.526v18.63c0 .336.192.48.527.48h15.66c.336 0 .527-.144.527-.48Z' />
);

export const viewBox = '0 0 25 25';
